import { ThemeTemplatesGridView } from '~/components/catalog/theme-templates';
import { PageContainer } from '~/components/page-container';

export function ThemeTemplates() {
	return (
		<PageContainer>
			<ThemeTemplatesGridView />
		</PageContainer>
	);
}
